module.exports = __webpack_public_path__ + "img/security_code_ios.7a416093.png";